var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-box" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1000px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "detailHead" }, [
              _c("div", { staticClass: "full" }, [
                _c("img", { attrs: { src: _vm.data.productImage, alt: "" } }),
                _c("div", { staticClass: "text" }, [
                  _c(
                    "div",
                    {
                      staticClass: "title line1",
                      attrs: { title: _vm.data.productName },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.productName) + " ")]
                  ),
                ]),
              ]),
              _c("ul", { staticClass: "list" }, [
                _c("li", { staticClass: "item" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("拼团状态")]),
                  _c(
                    "div",
                    {
                      staticClass: "titleStatus",
                      class:
                        _vm.data.recordStatus == 0
                          ? "info"
                          : _vm.data.recordStatus == 10
                          ? "success"
                          : "warning",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.data.recordStatus == 0
                              ? "拼团中"
                              : _vm.data.recordStatus == 10
                              ? "已成功"
                              : "已失败"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c("li", { staticClass: "item" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("成团人数")]),
                  _c("div", [_vm._v(_vm._s(_vm.data.buyingCountNum))]),
                ]),
                _c("li", { staticClass: "item" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("已参团人数")]),
                  _c("div", [_vm._v(_vm._s(_vm.data.yetBuyingNum))]),
                ]),
                _c("li", { staticClass: "item" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("开团时间")]),
                  _c("div", [_vm._v(_vm._s(_vm.data.createTime))]),
                ]),
                _c("li", { staticClass: "item" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("结束时间")]),
                  _c("div", [_vm._v(_vm._s(_vm.data.endTime))]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "table-line" }),
            _c(
              "div",
              { staticClass: "table-box detailHead" },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "mt20 orderDetailList",
                    attrs: { data: _vm.data.memberDataList, size: "small" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "用户头像" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "demo-image__preview" },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                    },
                                    attrs: {
                                      src: scope.row.memberAvatar,
                                      fit: "cover",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "用户信息", "min-width": "140" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "acea-row" }, [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.memberNickname)),
                                ]),
                                _c("span", { staticClass: "fenge" }, [
                                  _vm._v("|"),
                                ]),
                                _c("div", [_vm._v(_vm._s(scope.row.memberId))]),
                                scope.row.isLeader == 1
                                  ? _c("div", { staticClass: "leader" }, [
                                      _vm._v("团长"),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "订单编号",
                        prop: "orderNo",
                        "min-width": "190",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "商品规格", prop: "orderDetailSku" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "拼团时间",
                        prop: "createTime",
                        "min-width": "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "购买数量", prop: "payNum" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "实付金额", prop: "payPrice" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "已退款数量",
                        prop: "refundNum",
                        "min-width": "100",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }